import { Button } from "@/components/ui/button"
import { Heading } from "src/components/ui/heading"
import { css } from "styled-system/css"

export default function HvfDrawTool() {
  return (
    <article class={css({
      display: 'grid',
      gap: 3
    })}>

      <p>Our exclusive <strong>HVF Draw Tool</strong> is available for free to qualifying premium community members.</p>

      <p>This tool will assist you to draw precise HVFs quickly within TradingView.</p>

      <p>Here are just some of the highlights:</p>

      <p><strong>Precision and Accuracy</strong></p>
      <ul>
        <li><strong>Mathematically Accurate</strong>: This indicator uses algorithms to ensure every drawing is geometrically correct and HVF levels are mathematically precise, eliminating human error.</li>
        <li><strong>High Precision</strong>: Perfect for traders who rely on precise HVF patterns for their trading strategies.</li>
      </ul>

      <p><strong>Advanced HVF Drawings</strong></p>
      <ul>
        <li><strong>Complete Patterns</strong>: Capable of identifying and drawing complex HVF patterns. It includes automatic drawing of Primers and the ability to Scenariocast!</li>
        <li><strong>Customizable</strong>: Users can adjust the tools settings to match their specific preferences.</li>
      </ul>

      <p><strong>Efficiency</strong></p>
      <ul>
        <li><strong>Saves Time</strong>: Automates the process of drawing HVF patterns, saving you valuable time.</li>
        <li><strong>Ease of Use</strong>: The indicator can be applied with one click.</li>
        <li><strong>Visual Clarity</strong>: Clear and intuitive visualizations and feedback help you quickly understand the HVF under analysis.</li>
        <li><strong>Alerts</strong>: Offers real-time alerts when specific HVF levels are triggered.</li>
      </ul>

      <p>
        <a href="https://thesnipercircle.com/wp-content/uploads/2024/06/BNBUSD_2024-06-12_13-59-09.png">
          <img
            class="alignnone"
            src="https://spcdn.shortpixel.ai/spio/ret_img,q_cdnize,to_webp,s_webp/thesnipercircle.com/wp-content/uploads/2024/06/BNBUSD_2024-06-12_13-59-09-1024x567.png"
            alt="HVF Draw Tool Example"
            width="724"
            height="401"
          />
        </a>
      </p>

      <p><strong>How to qualify for the HVF Draw Tool</strong></p>
      <ul>
        <li>Completion of the one year Trading Metamorphosis Program (your Program start date + one year) <strong>AND</strong></li>
        <li>An active annual Sniper Circle membership. (All annual options)</li>
        <li>To apply, complete the form linked below using the email associated with your Sniper Circle account and we’ll enable access to the HVF Draw Tool to qualifying members.</li>
        <li>Access to the tool is synchronised to your annual membership.</li>
      </ul>

      <p>
        <Button
          onClick={() => window.open('https://docs.google.com/forms/d/e/1FAIpQLSfJ9la5-xh72YMuwaf7iyLN_NMwo96XumuMmFheZXiPS6-tzw/viewform?usp=sf_link', '_blank')}
        >
          Apply for your HVF Draw Tool here
        </Button>
      </p>

      <p><strong>How to use the HVF Draw Tool</strong></p>
      <ul>
        <li>Please follow the link below for the tutorial videos.</li>
      </ul>

      <p>
        <a href="https://thesnipercircle.com/courses/trading-essentials-mini-course/lessons/the-hvf-draw-tool/">
          Courses &gt; Essential Trading Tools &gt; The HVF Draw Tool
        </a>
      </p>

      <p><strong>IMPORTANT:</strong></p>

      <p>It is critically important that manual draws are done for the duration of your one-year Program to properly understand the principles and dynamics of the HVF Method before transitioning to using the HVF Draw Tool.</p>

      <p>The HVF Draw Tool removes the necessity of manually drawing your HVFs. <strong>It does not improve your trading or chances of success.</strong></p>

      <p>Improvement in your trading would be found in strict money management and adherence to the HVF Method.</p>

      <p>For any queries regarding the HVF Draw Tool please write to <a href="mailto:support@themarketsniper.com">support@themarketsniper.com</a></p>

    </article>
  )
}
